
import {React, _n} from 'pexui';
import {BasePage} from '../base';
import {showModal,ExitYodleeDialog} from '../dialog';
import {flow,getTrackLabel} from '../../models/flow'
import {track, trackClick} from '../../utilities/track';

export class YodleeBasePage extends BasePage {
    constructor(props){
        delete props.onClose;
        super(props);
    }

    hasFooter(){
        return false;
    }
    
    hasHelp(){
        return false;
    }

    getFooterButtons(){
        return [{
            id: 'infw_btn_exit_yodlee',
            label: _n('exit.yodlee.label'), 
            isPrimary: false, 
            onClick: this.onCancel.bind(this)
        }];
    }

    onCancel(evt){
        const widget = this.props.widget;
        if(flow.isYodleeOnly()){
            widget.onClose();
        }else{
            track("Yodlee:Exit", {contentName: getTrackLabel(flow.getCurrentNode())});

            (<ExitYodleeDialog
                onSelect={ value =>{
                    if(value === 'yes'){
                        track("Yodlee:Exit:YesExit", {contentName: getTrackLabel(flow.getCurrentNode())});
                        widget.nav('index');
                    }else{
                        trackClick('Click_NoGoBack');
                    }
                }}
            />).show();
        }
    }

}


// WEBPACK FOOTER //
// ./application/src/views/yodlee/yodleebase.jsx